module.exports = __webpack_public_path__ + "static/img/vans-logo.0143d53.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/vans-logo.png
// module id = ns5e
// module chunks = 0